import { render, staticRenderFns } from "./RecentlyAccessedRecords.vue?vue&type=template&id=051d4e68"
import script from "./RecentlyAccessedRecords.vue?vue&type=script&lang=js"
export * from "./RecentlyAccessedRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports